import { HOME_ROUTE } from '../../stores/page';
import { resetPreparatoryQuery } from '../../stores/searchQuery';

export default {
  [HOME_ROUTE]: (_, { dispatch }) => dispatch(resetPreparatoryQuery()),
};
